module.exports = __webpack_public_path__ + "media/fonts/Roboto-ThinItalic-082b9e840d3a498e8a3c8119f3a7132a.ttf";